import 'babel-polyfill'

import React from 'react';
import Quill from 'quill';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import { BrowserRouter, HashRouter } from 'react-router-dom'
import ReactGA from 'react-ga';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-joyride/lib/react-joyride-compiled.css';
import 'dabbl-react-components/build/styles.css';
import 'font-awesome/css/font-awesome.css';
import 'ionicons/dist/css/ionicons.css'

import './shared/assets/index.css';
import './shared/assets/utility-classes.css';

import Portal from './routes/Portal';
import store from './shared/redux';

import { 
  STRIPE_PUBLIC_KEY,
  HASH_URLS,
  GOOGLE_ANALYTICS_ID 
 } from './config';

const Router = HASH_URLS ? HashRouter : BrowserRouter;

ReactGA.initialize(GOOGLE_ANALYTICS_ID,{
  debug:false,
  titleCase:false,
  gaOptions:{
    cookieDomain:'auto'
  }
});

window.Quill = Quill;

ReactDOM.render((
    <StripeProvider apiKey={STRIPE_PUBLIC_KEY}>
      <Provider store={store}>
        <Router>
          <Portal />
        </Router>
      </Provider>
    </StripeProvider>
  ),
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js